import ContentOverlay from "../components/content_overlay";
import { Link } from "react-router-dom";

function LCAPage() {
  return (
    <ContentOverlay
      heading={
        <h2
          style={{
            textAlign: "center",
            fontFamily: "Nunito",
          }}
        >
          {" "}
          <b>Life Cycle Assessment</b>
        </h2>
      }
      text_content={
        <div>
          <p
            className="container"
            style={{
              fontSize: "0.8em",
              fontFamily: "Nunito",
            }}
          >
            <p>
              Considering the environmental uncertainties associated with
              bioenergy production as &nbsp;discussed in &nbsp;the Introduction
              part, it &nbsp;is imperative to &nbsp;analyze the pros and cons
              &nbsp;of bioenergy generation from a Life Cycle &nbsp;Assessment
              (LCA) prospective. The &nbsp;LCA is a tool to &nbsp;define the
              environmental burdens from a&nbsp; product, process or activity by
              identifying and quantifying energy and materials usage, as well
              &nbsp;as waste discharges, assessing the impacts of these wastes
              on &nbsp;the environment and it &nbsp;also&nbsp;&nbsp; evaluates
              the opportunities for environmental improvements over&nbsp;
              &nbsp;the &nbsp;whole life&nbsp;&nbsp; cycle&nbsp; &nbsp;(Singh
              and Olsen, &nbsp;2012). LCA also &nbsp;helps streamline the
              production process by &nbsp;suggesting the best alternatives to
              &nbsp;minimize the overall envi- ronmental impact. There are
              &nbsp;four &nbsp;main steps in LCA study: (a) goal and scope
              definition, where the goal and scope of the study, system
              boundary, functional unit are &nbsp;identified and defined, (b)
              &nbsp;life &nbsp;cycle inventory (LCI), life &nbsp;cycle &nbsp;of
              the product under study is modelled considering all the inputs and
              outputs; (c) life cycle &nbsp;inventory anal- ysis &nbsp;(LCIA),
              where the environmental relevance of&nbsp; all &nbsp;the inputs
              and outputs of a&nbsp; product is &nbsp;assessed, and, &nbsp;(d)
              &nbsp;Interpretation, the results of the study are &nbsp;reported
              and possible measures to &nbsp;reduce burden on &nbsp;the
              environment is suggested at this stage. The various phases of LCA
              study are &nbsp;shown in Fig. 1 (Rathore et al., 2013). So, LCA is
              basically a systematic study of a product&rsquo;s life cycle,
              &nbsp;primar- ily &nbsp;aiming at reducing its &nbsp;environmental
              burden (in &nbsp;other words increasing the product&rsquo;s
              environmental acceptability).
            </p>
            <p>
              In any &nbsp;bioenergy production system, the farming stage
              results in &nbsp;significant GHGs&nbsp; emissions and other
              environmental impacts due to &nbsp;the use &nbsp;of energy
              intensive farm machinery for&nbsp; irrigation, land preparation,
              sowing, harvest, collection and transportation of
              &nbsp;feedstock.&nbsp; Production &nbsp;and &nbsp;application
              &nbsp;of &nbsp;synthetic &nbsp;fertilizer and pesticide also
              &nbsp;lead to &nbsp;emissions and impacts soil &nbsp;and water
              quality. It&nbsp; is&nbsp; reported that, in &nbsp;case &nbsp;of
              sugarcane-based bioenergy generation, &nbsp;the
              &nbsp;farming&nbsp; stage &nbsp;has&nbsp; &nbsp;the &nbsp;highest
              &nbsp;environmental impacts due to &nbsp;land use,&nbsp;
              &nbsp;fuel&nbsp;&nbsp; and agro-chemicals consumption (Contreras
              et al., 2009). Sugarcane bagasse can &nbsp;be used for produc-
              tion of&nbsp; both bioelectricity and bioethanol. Lower
              &nbsp;energy related emissions could be &nbsp;achieved if bagasse
              is&nbsp; used for &nbsp;co-generation based electricity compared
              to &nbsp;bagasse bioethanol or&nbsp; fossil &nbsp;energy system
              (Botha and von Blottnitz, 2006; Ramjeawon, 2008). Further,
              integrated production of first &nbsp;generation (1G) &nbsp;and
              second genera- tion (2G) bagasse bioethanol has &nbsp;been
              proposed as an environmen- tally better option than 1G
              conventional production process (Gnansounou et al., 2015). In a
              comparative cradle-to-gate LCA of sugarcane bioethanol production
              in &nbsp;India and Brazil, &nbsp;Tsiropoulos et al. (2014)
              observed that Indian bioethanol causes lower or equal GHGs&nbsp;
              &nbsp;emissions, &nbsp;non-renewable&nbsp;&nbsp; energy
              &nbsp;use,&nbsp;&nbsp; &nbsp;human &nbsp;health impacts and
              ecosystem impairment compared to &nbsp;Brazilian bioethanol. The
              &nbsp;possible reason for &nbsp;such lower emissions is &nbsp;that
              the &nbsp;Indian bioethanol program&nbsp; is &nbsp;largely based
              &nbsp;on&nbsp; &nbsp;sugarcane molasses, &nbsp;a &nbsp;by-product
              of &nbsp;sugar production system, resulting in the allocation of
              environmental burden between product (sugar) and by-product
              (molasses). The&nbsp; cradle-to-gate LCA is a partial LCA from
              resource extraction (cradle) to &nbsp;factory gate (gate).
              On&nbsp; the other hand, the cradle-to-grave is the full LCA from
              resource extrac- tion (cradle) to &nbsp;waste disposal (grave).
            </p>
            <p>
              LCA studies have also &nbsp;demonstrated the environmental
              benefits of rice &nbsp;and corn residue based bioenergy production
              (Shafie et al., 2014; Sanscartier et al., &nbsp;2014; Nguyen et
              al., &nbsp;2013; Soam&nbsp; &nbsp;et al., 2017). Soam &nbsp;et al.
              (2017) reported that electricity production from rice &nbsp;straw
              produces a higher GHGs emissions reduction compared to
              &nbsp;biogas production&nbsp; in &nbsp;Indian condition. In
              &nbsp;Malaysia also, &nbsp;rice straw based power generation
              was&nbsp; &nbsp;indicated to &nbsp;emit less &nbsp;GHGs in
              comparison with coal &nbsp;or natural gas &nbsp;(Shafie et al.,
              2014). How- ever, &nbsp;according to &nbsp;Silalertruksa and
              Gheewala (2013), bioethanol production from rice &nbsp;straw
              results in higher environmental benefit compared to
              combustion-based power production or thermo- chemical conversion
              of &nbsp;straw to &nbsp;Biomass-Dimethyl Ether (bio- DME). On the
              other hand, according to Tonini et al. (2016), biofuel production
              from agro-residues without involving land use &nbsp;change is
              &nbsp;a&nbsp; promising emissions reduction option, but the
              feed-sector&rsquo;s annual crops or &nbsp;residues should not
              &nbsp;be &nbsp;used to &nbsp;produce biofuel, as land use
              &nbsp;change related GHGs emissions exceeds any &nbsp;GHGs sav-
              ings &nbsp;from displacing conventional energy sources. Using
              &nbsp;corn cob as &nbsp;fuel &nbsp;pellets for &nbsp;electricity
              generation, a 40% and 80% reduction in &nbsp;GHGs&nbsp; emissions
              compared to coal &nbsp;and natural gas &nbsp;combined cycle
              &nbsp;(NGCC) has &nbsp;been reported by &nbsp;Sanscartier et al.
              &nbsp;(2014). LCA study also &nbsp;finds that co-firing of biomass
              with coal &nbsp;results in sub- stantial emissions reduction
              (Sebasti&aacute;n et al., 2011). However, the quantity of&nbsp;
              emissions reduction will &nbsp;depend upon the degree of biomass
              pre-treatment &nbsp;and coal &nbsp;boiler efficiency and hence the
              use&nbsp; &nbsp;biomass with low&nbsp; &nbsp;pre-treatment
              &nbsp;and with minimum effect on &nbsp;boiler efficiency is
              suggested to &nbsp;maximize emissions reduction (Sebasti&aacute;n
              et al., 2011). Furthermore, the size &nbsp;and design parame- ters
              of biomass power plant also &nbsp;influence the emission pattern.
              Butnar et al. (2010) reported that, biomass power plant with gen-
              eration capacity in &nbsp;the range of 10&ndash;25 MW &nbsp;yield
              better environ- mental performance, since for &nbsp;bigger power
              plant (&gt;25 MW), &nbsp;the higher &nbsp;efficiency of
              &nbsp;electricity production &nbsp;is &nbsp;overtaken&nbsp;
              by&nbsp; &nbsp;the higher biomass transport distance and
              constraints of&nbsp; land avail- ability for &nbsp;biomass
              cultivation. A. Singh &nbsp;et al. &nbsp;(2011), &nbsp;through a
              LCA study reported that the type of biogas reactor has &nbsp;an
              influence on &nbsp;emissions savings by &nbsp;up &nbsp;to
              &nbsp;15%. Although the use &nbsp;of biomass (such as &nbsp;wheat
              straw, poplar and Ethiopian mustard) as &nbsp;a substi- tute
              &nbsp;to&nbsp; &nbsp;coal&nbsp;&nbsp; &nbsp;or&nbsp; &nbsp;natural
              &nbsp;gas&nbsp;&nbsp;&nbsp; reduces &nbsp;global &nbsp;warming,
              &nbsp;non- renewable energy use, &nbsp;human toxicity and
              eco-toxicity, however, it &nbsp;also&nbsp; &nbsp;leads to
              &nbsp;increased risk&nbsp;&nbsp; of &nbsp;eutrophication,
              photochemical ozone and respiratory inorganic (Nguyen et al.,
              &nbsp;2013; Kimming et al., 2011).
            </p>
            <p style={{ textAlign: "center" }}>
              <img
                src="https://wgbis.ces.iisc.ac.in/energy/paper/Emerging-role-of-Geographical-Information-System/f1.png"
                alt=""
                width="706"
                height="942"
              />
            </p>
            <p>
              The above LCA discussions suggest that, residue bioenergy have
              certain environmental superiorities over &nbsp;conventional fuels,
              &nbsp;if uti- lized in a sustainable way. &nbsp;However, since the
              same biomass feed- stock can be used through multiple energy
              conversion routes (heat, electricity, bioethanol), therefore
              &nbsp;it &nbsp;is &nbsp;important to &nbsp;identify the most
              &nbsp;beneficial route &nbsp;of &nbsp;conversion. &nbsp;In
              &nbsp;this &nbsp;regard, &nbsp;Cherubini et al. &nbsp;(2009)
              reported that (i) &nbsp;production of &nbsp;heat and electricity
              from biomass has &nbsp;higher GHGs &nbsp;emissions reduction and
              energy saving benefits than the production of biofuel, (ii)
              &nbsp;waste/residue biomass shows best environmental performance,
              since they avoid both the impacts of energy crop production and
              the emissions from waste management. For enhanced GHGs emissions
              reduction, Muench (2015) recommended &nbsp;deployment&nbsp; of
              &nbsp;(i) &nbsp;non-dedicated ligno-cellulosic biomass &nbsp;with
              &nbsp;thermo-chemical &nbsp;conversion,&nbsp; (ii) dedicated
              &nbsp;ligno-cellulosic&nbsp; biomass &nbsp;with
              &nbsp;thermo-chemical conversion and (iii) &nbsp;dedicated
              ligno-cellulosic biomass with direct combustion. Use of biomass
              waste/residue has &nbsp;also &nbsp;been suggested as&nbsp; &nbsp;a
              &nbsp;better &nbsp;emission reduction &nbsp;option &nbsp;than
              &nbsp;replacing existing croplands &nbsp;or&nbsp; &nbsp;clearing
              &nbsp;new &nbsp;lands &nbsp;for&nbsp; &nbsp;energy &nbsp;crop
              &nbsp;plantation (Fargione et al., 2008; Searchinger et al., 2008;
              Ho et al., 2014).
            </p>
            <p>&nbsp;</p>
            <h3>Uncertainties in bioenergy LCA</h3>
            <p>
              As discussed in the previous section, though the environmental
              benefits of bioenergy over &nbsp;fossil &nbsp;energy has
              &nbsp;been realized through LCA studies, however, there are
              &nbsp;some uncertainties related to &nbsp;LCA applicability
              (Hellweg and Canals, 2014). The &nbsp;variations may be due to the
              differences in the type and management of raw materi- als,
              &nbsp;conversion technologies, end use &nbsp;technologies and the
              choice of &nbsp;LCA methodologies
              (consequential/attributional/hybrid &nbsp;LCA) (Cherubini et al.,
              &nbsp;2009; Muench, 2015; Muench and Guenther, 2013). Lack
              &nbsp;of &nbsp;general consensus regarding the definition of&nbsp;
              the system boundary, fossil &nbsp;reference system, optimal
              functional unit, ideal allocation of environmental impact between
              products and co- products, &nbsp;modelling &nbsp;carbon
              &nbsp;cycle&nbsp;&nbsp;&nbsp; of&nbsp; &nbsp;biomass
              &nbsp;(biogenic/non- biogenic &nbsp;carbon &nbsp;flow)&nbsp;&nbsp;
              &nbsp;also&nbsp;&nbsp; &nbsp;lead &nbsp;to&nbsp; &nbsp;variations
              &nbsp;(Muench&nbsp; and Guenther, 2013; Choudhary et al., 2014).
              In addition, the collection of actual data for LCA study is a
              challenging task, &nbsp;as these datasets may vary
              &nbsp;temporally and spatially (Singh et al., 2013). Allocation is
              a very &nbsp;sensitive issue in LCA which affects the results
              significantly. The &nbsp;inappropriate allocations could lead to
              &nbsp;incorrect LCA results. Allocation is a procedure of
              appropriately allocating the environ- mental burdens of a
              multi-functional process among its &nbsp;functions or products
              (Reap &nbsp;et al., 2008). Allocation step is one &nbsp;of the
              deter- mining steps that tell&nbsp;&nbsp; how much of &nbsp;the
              environmental burden caused by &nbsp;a
              &nbsp;multi-functional&nbsp; process should be &nbsp;apportioned
              to each product or &nbsp;function (Singh and Olsen,&nbsp;
              &nbsp;2012). Plevin et&nbsp; al. (2014) cautioned that LCA results
              should refrain from using unsup- ported claims, such as
              &lsquo;&lsquo;using product X results in a Y% reduction in GHG
              emission compared to product Z&rdquo; because such claims are
              &nbsp;valid only &nbsp;in rare cases.
            </p>
            <p>
              The &nbsp;limitations of LCA must be &nbsp;taken into account
              while con- ducting bioenergy LCA. Hellweg and Canals (2014)
              suggested that it is a duty of the LCA practitioners to explain to
              the decision mak- ers &nbsp;that LCA is not &nbsp;always a tool
              &nbsp;to provide a single answer, but it gives &nbsp;a
              comprehensive understanding of a problem and its possible
              solutions.&nbsp; Muench &nbsp;(2015) &nbsp;recommended
              &nbsp;numbers &nbsp;of &nbsp;ways to increase the reliability of
              LCA results which includes: (i) LCA can be &nbsp;further improved
              by &nbsp;accounting for &nbsp;heterogeneity among bio- mass
              systems, (ii) the strong influence of small differences in bio-
              mass systems&nbsp; must &nbsp;be&nbsp; &nbsp;considered while
              interpreting &nbsp;the &nbsp;LCA results, (iii) transferability of
              LCA results between similar systems must always be investigated,
              (iv) adopting assumptions from other systems should be avoided
              since it may lead to errors, (v) analysis of &nbsp;GHGs
              &nbsp;emissions mitigation potential &nbsp;is &nbsp;only&nbsp;
              &nbsp;a &nbsp;first&nbsp; &nbsp;step&nbsp; in assessing the&nbsp;
              sustainability of &nbsp;biomass derived electricity and hence
              future LCA research should include additional environmen- tal,
              &nbsp;economic and social impact categories. Further, it should
              also be noted that since a real &nbsp;life situation is modelled
              in LCA, so, there is &nbsp;a&nbsp; possibility of distortion of
              the reality in &nbsp;the model outcome (Goedkoop et al., 2013).
              Hence, developing LCA model with prior knowledge of the system
              under investigation and careful selection of the system parameters
              is important to &nbsp;minimize bias &nbsp;between reality and
              model output and gain &nbsp;a true picture of the environ- mental
              benefits of bioenergy.
            </p>
            <p>&nbsp;</p>
            <h3>Spatial LCA in bioenergy and environmental planning</h3>
            <p>
              Due &nbsp;to &nbsp;the distributed nature of&nbsp; biomass
              resources, environ- mental &nbsp;impacts &nbsp;of&nbsp;&nbsp;
              bioenergy &nbsp;may &nbsp;have &nbsp;spatial &nbsp;consequences
              too, &nbsp;especially with regards to &nbsp;land use &nbsp;and
              biodiversity. Exclud- ing &nbsp;the impact on &nbsp;biodiversity
              in &nbsp;LCA studies can&nbsp; &nbsp;significantly limit the
              applicability of &nbsp;LCA findings (Geyer et al., &nbsp;2010;
              Baan et al., &nbsp;2013).&nbsp; In &nbsp;many &nbsp;bioenergy LCA
              studies, average country level &nbsp;values are &nbsp;taken as
              input data. However, parameters such as grain productivity,
              residue to &nbsp;grain production ratio, surplus resi- due
              availability, competing uses of residue may vary &nbsp;from region
              to region. Thus, &nbsp;considering country level &nbsp;average
              data for local &nbsp;or regional representation may lead to
              &nbsp;erroneous result. This &nbsp;is par- ticularly true for
              &nbsp;large scale biomass power plants, where feed- stocks&nbsp;
              are&nbsp; &nbsp;collected &nbsp;from &nbsp;large
              &nbsp;geographical &nbsp;areas. &nbsp;Traditional LCAs are
              &nbsp;unable to &nbsp;recognize the spatial dimension of
              &nbsp;environ- mental impacts of &nbsp;bioenergy but it &nbsp;can
              &nbsp;be &nbsp;addressed if the LCA is conducted on &nbsp;a GIS
              platform (Geyer et al., 2010). Use &nbsp;of Infor- mation
              Technology supported LCA enables to &nbsp;analyze and visual- ize
              &nbsp;material flows,&nbsp; &nbsp;processes or &nbsp;products and
              the calculation of eco-balances &nbsp;on&nbsp; &nbsp;spatial
              &nbsp;scale&nbsp; (Dresen and &nbsp;Jandewerth, &nbsp;2012).
              Applying spatio-temporal&nbsp;&nbsp; models &nbsp;can&nbsp;
              &nbsp;improve the &nbsp;spatial and temporal depths of LCA
              analysis (Arodudu et al., 2017). Regional- ized &nbsp;LCA using
              spatial platform increases the accuracy of assess- ment
              &nbsp;by&nbsp; &nbsp;accounting &nbsp;site-specific&nbsp;
              production &nbsp;conditions &nbsp;along with differences in
              &nbsp;transport and the sensitivity of &nbsp;ecosystems (Hellweg
              and Canals, 2014). However, limited literature &nbsp;is
              &nbsp;avail- able &nbsp;on spatial LCA. Therefore, the following
              discussion is not &nbsp;lim- ited to &nbsp;residue bioenergy but
              various forms of bioenergy are &nbsp;also covered.
            </p>
            <p>
              Land &nbsp;use &nbsp;impact on &nbsp;biodiversity is difficult to
              &nbsp;predict because of&nbsp; the spatial heterogeneity of&nbsp;
              biodiversity and unavailability of precise impact assessment tool
              &nbsp;(Geyer et al., 2010). The integrated use &nbsp;of GIS and
              LCA (spatial LCA) could give &nbsp;important insight into how
              &nbsp;land &nbsp;use&nbsp; &nbsp;change &nbsp;could &nbsp;impact
              &nbsp;biodiversity.&nbsp; Geyer et &nbsp;al. (2010) presented
              &nbsp;a &nbsp;proof-of-concept &nbsp;(Fig. &nbsp;2) &nbsp;by
              &nbsp;integrating GIS and LCA together for &nbsp;impact assessment
              of &nbsp;ethanol production on &nbsp;land use &nbsp;and
              biodiversity in &nbsp;California. The &nbsp;study found that GIS
              &nbsp;based &nbsp;inventory &nbsp;modelling&nbsp; of &nbsp;land
              &nbsp;use&nbsp; &nbsp;allows important refinement in &nbsp;LCA and
              using GIS, land use &nbsp;can &nbsp;be &nbsp;modelled as &nbsp;a
              geospatial and nonlinear function of&nbsp; output. Humpenoder et
              al. (2013) combined GIS based LandSHIFT model with LCA to investi-
              gate the land use &nbsp;impact on &nbsp;the carbon balance of
              biofuel in &nbsp;the European Union (EU). &nbsp;The &nbsp;results
              indicate that land use &nbsp;change has &nbsp;a &nbsp;major impact
              on &nbsp;the GHGs &nbsp;emissions performance of&nbsp; bio- fuel.
              &nbsp;In &nbsp;a &nbsp;different study, Geyer et al. &nbsp;(2013)
              presented a &nbsp;spatial LCA approach of &nbsp;sun-to-wheels
              &nbsp;energy conversion pathways in the US considering land use
              &nbsp;impacts, life &nbsp;cycle &nbsp;GHGs &nbsp;emissions and
              fossil &nbsp;fuel &nbsp;demand for five different sun-to-wheels
              conversion pathways. Azapagic et &nbsp;al. &nbsp;(2013) developed
              a &nbsp;decision support system called PUrE which integrates
              several environmental assessment &nbsp;tools in &nbsp;one&nbsp;
              &nbsp;platform for &nbsp;sustainability assessment of&nbsp;
              &nbsp;human&nbsp; &nbsp;activities &nbsp;on&nbsp;&nbsp;
              &nbsp;the&nbsp;&nbsp; urban &nbsp;environment.
              &nbsp;The&nbsp;&nbsp; &nbsp;sub- components of the tool
              &nbsp;includes GIS, LCA, substance flow &nbsp;analysis (SFA), air
              &nbsp;dispersion modelling (ADM), health impact assessment (HIA)
              &nbsp;and&nbsp; multi-criteria &nbsp;decision analysis (MCDA).
              &nbsp;Gasol&nbsp; &nbsp;et &nbsp;al. (2011) conducted a spatial
              LCA study to&nbsp; investigate decentralized bioenergy potential
              based on &nbsp;Brassica &nbsp;spp. &nbsp;and Populus &nbsp;spp.
              &nbsp;The GIS is &nbsp;used to &nbsp;estimate bioenergy production
              while the LCA is applied to &nbsp;estimate potential CO2
              &nbsp;emission reduction from bioen- ergy &nbsp;power plants.
              Mutel et al. &nbsp;(2012) proposed a&nbsp; GIS combined LCA method
              for regionalized LCA on spatial platform using Bright- way
              &nbsp;software which directly includes GIS capabilities in&nbsp;
              the LCA calculation. Dresen and Jandewerth (2012) combined geo-
              informatics with LCA to conduct spatial analysis of biogas produc-
              tion in &nbsp;Germany. Under the &nbsp;HEDGE-BIOMASS project,
              Ferrarini et al. (2014) proposed a combination of GIS, LCA and
              SWAT model to &nbsp;investigate landscape level&nbsp;&nbsp;
              bioenergy production in &nbsp;order to identify how and where
              bioenergy can &nbsp;be &nbsp;produced sustainably and how to
              &nbsp;optimize the trade-off between delivery of &nbsp;multiple
              ecological services&nbsp; and &nbsp;farmers &nbsp;benefit
              &nbsp;within &nbsp;limited &nbsp;land resources. Integration of
              &nbsp;GIS into LCA for &nbsp;impact&nbsp; assessment &nbsp;of
              algal &nbsp;biofuel production from wastewater has &nbsp;also
              &nbsp;been recently reported by &nbsp;Roostaei and Zhang (2016).
            </p>
            <div align="center">
              <img
                src="https://wgbis.ces.iisc.ac.in/energy/paper/Emerging-role-of-Geographical-Information-System/sec3_clip_image002.jpg"
                alt=""
                width="567"
                height="376"
              />
            </div>
            <p>
              Fig. &nbsp;2. &nbsp;A procedure to integrate GIS into LCA for
              &nbsp;the assessment of environmental implications of biofuel
              production (Geyer et al., 2010). The &nbsp;interface between GIS
              and LCA are indicated by &nbsp;bold arrows. Here, GIS provides
              land use land cover and biodiversity habitat data to the LCA
              framework to identify the bioenergy impact on biodiversity
              elements.
            </p>
            <p align="justify">&nbsp;</p>

            <br />
            <br />
            <hr />
            <br />
          </p>
        </div>
      }
    />
  );
}
export default LCAPage;
